import React from 'react';
import { useHistory } from 'react-router';
import { useAuth } from '../../hooks/useAuth';
import AccountSelect, { BasicAccount } from '../../components/account/AccountSelect';
import { useAsync } from 'react-use';
import config from '../../config/config';
import { useGetAccountsQuery } from '../../generated/types';

const RestaurantsPage: React.FC = () => {
    const isLoggedIn = useAuth();
    const history = useHistory();

    const { data } = useGetAccountsQuery({
        variables: { limit: 100, offset: 0 },
    });

    const onClickDone = (account: BasicAccount) => {
        window.location.href = `${process.env.REACT_APP_ENDPOINT}/account/${account.id}/home`;
    };

    useAsync(async () => {
        if (isLoggedIn) {
            if (data?.accounts?.length === 0) {
                history.replace(`/getstarted`);
            } else if (data?.accounts?.length === 1) {
                history.replace(`account/${data.accounts[0].id}/home`);
            }
        } else {
            const uri = window.encodeURIComponent(`${config.appUrl}/business`);
            window.location.href = `${config.authUrl}/login?redirect_uri=${uri}`;
        }
    }, [isLoggedIn, data]);

    return (
        <div className="pt-28 pb-28 px-30 h-full flex flex-col bg-white">
            <AccountSelect
                title="Select Account"
                subtitle="Select which account you’d like to use."
                onSelect={(account) => {
                    onClickDone(account);
                }}
            ></AccountSelect>
        </div>
    );
};

export default RestaurantsPage;
